// @tb/ui/dashboard — общие блоки дашборда (ЛК + B2B).
// Один источник правды для визуального оформления результатов тестов.
export { default as RadarChart } from './RadarChart';
export { scoreColor, scoreBg } from './polarity';
export { BigFiveBlock } from './BigFiveBlock';
export { DiscBlock } from './DiscBlock';
export { EqBlock } from './EqBlock';
export { SchwartzBlock } from './SchwartzBlock';
export { SynthesisBlock } from './SynthesisBlock';
export { DescriptionsProvider, useDescriptions, useTestDescriptions } from './descriptions-context';
export { AspectNamesProvider, useAspectNames } from './aspect-names-context';
export * from './synthesis-content';
